module.exports = __webpack_public_path__ + "img/sign_apply_preview.4d4037d6.png";